<template>
  <div class="item">
    <div class="container">
      <section class="bg white mt-sm-5 mt-3">
        <div class="row p-3">
          <div class="col-md-6">
            <div class="product-details__gallery">
              <ItemSlick :images="item.images"/>
              <div id class="js-gallery-thumb gallery gallery--thumb"></div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="product-details__shopping">
              <h2 class="ui text huge-lg big-sm large color black mb-0 mb-dm-2">{{item.titleTH}}</h2>
              <p
                v-if="item.skus.length > 1 && item.skus[0].netPrice != item.skus[item.skus.length -1].netPrice "
                class="ui text big-lg medium-md big bold [ color red-2 ] m-0"
              >{{currency}}{{formatPrice(item.skus[0].netPrice)}} - {{currency}}{{formatPrice(item.skus[item.skus.length -1].netPrice)}}</p>
              <p
                v-else
                class="ui text big-lg medium-md big bold [ color red-2 ] m-0"
              >{{currency}}{{formatPrice(item.netPrice)}}</p>
              <p
                v-if="item.price != item.netPrice "
                class="ui text big-lg medium-md tiny-sm small light line-through m-0"
              >{{currency}}{{formatPrice(item.price)}}</p>
              <p v-else class="price-none">&nbsp;</p>
              <!-- <hr class="gray-7">
                            <div class="d-flex pt-2 pb-2">
                                <span class="ui text big-lg medium-md small-sm tiny color theme align-items-center d-flex">
                                    <i class="icon-custom-delivery large mr-2"></i> การจัดส่ง
                                </span> 
                                <span class="ui text big-lg medium-md small-sm tiny gray-7 align-items-center d-flex ml-auto">ค่าบริการจัดส่ง 50 บาท</span>
              </div>-->
              <hr v-if="item.skuOptions.length > 0" class>
              <div v-if="item.skuOptions[0]" class="row pt-2 pb-2">
                <div class="col-3 align-self-center">
                  <div
                    class="ui text big-lg medium-md small-sm tiny color theme align-items-center d-flex"
                  >{{item.skuOptions[0].name}}</div>
                </div>
                <div class="col">
                  <div class="ui text big-lg medium-md small-sm">
                    <div
                      v-for="(item, index) in item.skuOptions[0].skus"
                      :key="index"
                      class="select-box-sku"
                      :class="{'active' : selectSku1 == item.id}"
                    >
                      <label>
                        <span :class="{'non-active' : checkQuantity(item.id)}">{{item.name}}</span>
                        <input
                          v-if="!checkQuantity(item.id)"
                          type="radio"
                          v-model="selectSku1"
                          :value="item.id"
                        >
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="item.skuOptions[1]" class="row pt-2 pb-2">
                <div class="col-3 align-self-center">
                  <div
                    class="ui text big-lg medium-md small-sm tiny color theme align-items-center d-flex"
                  >{{item.skuOptions[1].name}}</div>
                </div>
                <div class="col">
                  <div class="ui text big-lg medium-md small-sm">
                    <div
                      v-for="(item, index) in item.skuOptions[1].skus"
                      :key="index"
                      class="select-box-sku"
                      :class="{'active' : selectSku2 == item.id }"
                    >
                      <label>
                        <span :class="{'non-active' : checkQuantity(null,item.id)}">{{item.name}}</span>
                        <input
                          v-if="!checkQuantity(null,item.id)"
                          type="radio"
                          v-model="selectSku2"
                          :value="item.id"
                        >
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <hr class>
              <div class="d-flex align-items-center pt-2 pb-2">
                <span
                  class="ui text big-lg medium-md small-sm tiny color theme align-items-center d-flex"
                >{{$t('Amount')}}</span>
                <div class="input-quantity ui action input ml-5 col-2">
                  <button @click="decrement()" class="ui icon basic button left">
                    <i class="minus icon color theme"></i>
                  </button>
                  <input class="ui input" v-model="amount">
                  <button @click="increment()" class="ui icon basic button right">
                    <i class="plus icon color theme"></i>
                  </button>
                </div>
                <div class="col-5 ml-auto text-right">
                  <span
                    v-if="quantity"
                    class="ui text big-lg medium-md small-sm tiny color black ml-2"
                  >{{$t('TotalAmount',{quantity: quantity})}}</span>
                  <span
                    v-if="quantity == 0"
                    class="ui text big-lg medium-md small-sm tiny color red-2 ml-2"
                  >{{$t('SoldOut')}}</span>
                </div>
              </div>
              <hr class>
              <div class="row align-items-center py-md-2 product-details__btns">
                <div class="col-12">
                  <div class="row mb-2">
                    <div class="col-6">
                      <span
                        class="ui text big-lg medium-md small-sm tiny color theme align-items-center"
                      >{{$t('Total')}}</span>
                    </div>
                    <div class="col-6 text-right">
                      <span class="ui text huge-lg medium-md small-sm tiny bold color red-2">
                        <span class="ml-2">{{currency}}{{formatPrice(item.netPrice * amount)}}</span>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="row">
                    <div class="col-6">
                      <AddToCart :btnStyle="'style5'" :product="getProduct()" :goCart="goCart"/>
                    </div>
                    <div class="col-6">
                      <AddToCart :btnStyle="'style3'" :product="getProduct()"/>
                    </div>
                  </div>
                </div>
                <Favorite :productId="item.id" :type="3"></Favorite>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        v-if="item.codeDetailTH != '<div> </div>' && item.codeDetailTH != '<div></div>' && item.codeDetailTH != '' "
        class="bg white mt-sm-5 mt-3"
      >
        <h3 class="ui header large-lg medium-md small black p-4 pb-2 mb-0">{{$t('DetailProduct')}}</h3>
        <hr class="mt-0">
        <div class="p-3 texteditor" v-html="item.codeDetailTH"></div>
      </section>
    </div>
  </div>
</template>
<script>
import ItemSlick from "@/components/items/ItemSlick.vue";
import ItemSlickSub from "@/components/items/ItemSlickSub.vue";
import AddToCart from "@/components/cart/AddItem.vue";
import Favorite from "@/components/favorite/AddFavorite.vue";
import _ from "lodash";
import { mapMutations } from "vuex";

const axios = require("axios");
export default {
  name: "item",
  components: {
    ItemSlick,
    ItemSlickSub,
    AddToCart,
    Favorite
  },
  props: {},
  data() {
    return {
      loading: true,
      item: {
        skuOptions: [],
        skus: []
      },
      defaultPrice: 0,
      amount: 1,
      selectSku1: null,
      selectSku2: null,
      quantity: 0,
      currency: "",
      goCart: true
    };
  },
  created() {
    this.currency = this.$parent.currency;
    let id = this.$route.params.id;
    this.getItem(id);
  },
  methods: {
    ...mapMutations(["ADD_CART_LOCAL"]),
    buyNow() {
      let product = {};
      product.selected = {
        selectSku1: this.selectSku1,
        selectSku2: this.selectSku2
      };
      product.amount = this.amount;
      this.$http
        .get("products/" + this.$route.params.id)
        .then(response => {
          let item = response.data.data;
          if (item.quantity == 0) {
            let message = this.$t("OutStock");
            this.$parent.message = {
              message: message,
              title: this.$t("ShoppingCart")
            };
            this.$parent.showMessage = !this.$parent.showMessage;
            return;
          }
          let newProduct = {
            itemId: Date.now(),
            id: item.id,
            image: item.images[0] ? item.images[0].url : null,
            name: item.titleTH,
            amount: 1,
            quantity: item.quantity
          };
          if (item.skus.length) {
            if (product.selected && product.selected.selectSku1 != null) {
              let data = _.find(item.skus, {
                sku1Id: product.selected.selectSku1,
                sku2Id: product.selected.selectSku2
              });
              if (data) {
                newProduct.quantity = data.quantity;
                newProduct.sku = data;
                newProduct.price = data.price;
                newProduct.netPrice = data.netPrice;
              } else {
                return;
              }
            } else {
              newProduct.quantity = item.skus[0].quantity;
              newProduct.sku = item.skus[0];
              newProduct.price = item.skus[0].price;
              newProduct.netPrice = item.skus[0].netPrice;
            }
          } else {
            newProduct.sku = null;
            newProduct.price = item.price;
            newProduct.netPrice = item.netPrice;
          }
          if (product.amount && newProduct.quantity >= product.amount) {
            newProduct.amount = product.amount;
          }
          this.ADD_CART_LOCAL(newProduct);
          this.$router.push("/cart");
        })
        .catch(error => console.log(error));
    },
    getProduct() {
      this.item.selected = {
        selectSku1: this.selectSku1,
        selectSku2: this.selectSku2
      };
      this.item.amount = this.amount;
      return this.item;
    },
    getSKU() {
      return this.item.options;
    },
    getItem(id) {
      this.$http
        .get("products/" + id)
        .then(response => {
          this.item = response.data.data;
          console.log(this.item);
          this.defaultPrice = this.item.price;
          this.quantity = this.item.quantity;
        })
        .catch(error => {
          this.$router.go(-1);
        })
        .finally(() => (this.loading = false));
    },
    formatPrice(value) {
      let price = Number(value);
      return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    increment() {
      if (this.amount < this.quantity) {
        this.amount++;
      }
    },
    decrement() {
      if (this.amount > 1) {
        this.amount--;
      }
    },
    findPrice() {
      this.amount = 1;
      let skus = this.item.skus;
      let data = _.find(skus, {
        sku1Id: this.selectSku1,
        sku2Id: this.selectSku2
      });
      if (data) {
        this.quantity = data.quantity;
        this.item.netPrice = data.netPrice;
        this.item.price = data.price;
      } else {
        this.quantity = null;
        this.item.price = 0;
        this.item.netPrice = 0;
      }
    },
    checkQuantity(sku1, sku2 = null) {
      let sku1Id = sku1 == null ? this.selectSku1 : sku1;
      let sku2Id = sku2;
      let data = _.find(this.item.skus, { sku1Id: sku1Id, sku2Id: sku2Id });
      if (data) {
        if (data.quantity == 0) {
          return true;
        }
      }
      return false;
    }
  },
  mounted() {
    $(function() {
      $("html,body").animate({ scrollTop: $("body").offset().top }, "1000");
    });
  },
  computed: {},
  watch: {
    selectSku1() {
      this.selectSku2 = null;
      this.findPrice();
    },
    selectSku2(val) {
      if (val == null) {
        return;
      }
      this.findPrice();
    },
    selected(sku) {
      console.log(sku);
      // this.item.price = sku.price
      // this.item.netPrice = sku.price
    },
    amount(val) {
      if (!isNaN(this.amount)) {
        if (this.amount < 1) {
          this.amount = 1;
        }
        if (this.amount > this.quantity) {
          this.amount = this.quantity;
        }
      } else {
        this.amount = 1;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.select-box-sku {
  border: 2px solid #fff;
  float: left;
  margin-left: 1rem;
  position: relative;
  &.active {
    border: 2px solid red;
  }
  label {
    border: 1px solid rgba(0, 0, 0, 0.1);
    padding: 0.2rem 0.4rem;
    margin-bottom: 0rem;
    min-width: 39px;
    text-align: center;
    input {
      position: absolute;
      opacity: 0;
    }
    .non-active {
      opacity: 0.4;
    }
  }
}
.price-none {
  height: 19px;
}
</style>